<template>
  <b-row>
    <b-col cols="12">
      <h1 class="pull-left">Profile</h1>
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="6">
            <b-form-group
              id="input-group-1"
              label="Email:"
              label-for="kiotp-my-profile-email"
            >
              <b-form-input
                id="kiotp-my-profile-email"
                v-model="form.email"
                type="email"
                placeholder="Email"
                trim
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group
              id="input-group-2"
              label="First Name:"
              label-for="kiotp-my-profile-firstname"
            >
              <b-form-input
                id="kiotp-my-profile-firstname"
                v-model="form.firstName"
                placeholder="First Name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              id="input-group-3"
              label="Last Name:"
              label-for="kiotp-my-profile-lastname"
            >
              <b-form-input
                id="kiotp-my-profile-lastname"
                v-model="form.lastName"
                placeholder="Last Name"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group
              id="input-group-4"
              label="Phone:"
              label-for="kiotp-my-profile-phone"
            >
              <b-form-input
                id="kiotp-my-profile-phone"
                v-model="form.phoneNumber"
                placeholder="Phone"
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group
              id="input-group-5"
              label="Password:"
              label-for="kiotp-my-profile-password"
            >
              <b-input-group>
                <template #append>
                  <b-input-group-text
                    @click="togglePasswordVisibility"
                    class="group-text"
                    ><span v-if="passwordVisibility === 'password'" key="closed"
                      ><i class="eye-icon fa fa-eye"></i
                    ></span>
                    <span v-else key="open"
                      ><i class="eye-icon fa fa-eye-slash"></i
                    ></span>
                  </b-input-group-text>
                </template>
                <b-form-input
                  id="kiotp-my-profile-password"
                  v-model="passwords.password"
                  placeholder="Password"
                  :state="confirmPasswordInputState"
                  :type="passwordVisibility"
                  trim
                >
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback :state="confirmPasswordInputState">
                Passwords must match
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              id="input-group-6"
              label="Confirm password:"
              label-for="kiotp-my-profile-confirm"
            >
              <b-form-input
                id="kiotp-my-profile-confirm"
                v-model="passwords.confirmPassword"
                placeholder="Confirm password"
                :state="confirmPasswordInputState"
                :type="passwordVisibility"
                trim
              ></b-form-input>
              <b-form-invalid-feedback :state="confirmPasswordInputState">
                Passwords must match
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-button
              type="submit"
              variant="primary"
              class="pull-left"
              :disabled="isSubmiting"
              >Submit</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

export default {
  name: 'MyProfile',
  setup(_, { root }) {
    let isSubmiting = ref(false);
    let passwordVisibility = ref('password');
    const currentUser = computed(() => root.$store.state.auth.currentUser);
    const form = ref({ ...currentUser.value.content });
    const passwords = ref({
      password: null,
      confirmPassword: null
    });

    return {
      form,
      isSubmiting,
      passwords,
      confirmPasswordInputState: computed(() =>
        !passwords.value.password && !passwords.value.confirmPassword
          ? null
          : passwords.value.password === passwords.value.confirmPassword
      ),
      passwordVisibility,
      togglePasswordVisibility: () => {
        if (passwordVisibility.value === 'password') {
          passwordVisibility.value = 'text';
        } else {
          passwordVisibility.value = 'password';
        }
      },
      onSubmit: async () => {
        if (isSubmiting.value) return;
        isSubmiting.value = true;
        delete form.value.profileIds;
        try {
          await root.$kuzzle.auth.updateSelf(form.value);
          if (
            passwords.value.password !== '' &&
            passwords.value.password !== null &&
            passwords.value.password !== undefined
          ) {
            await root.$kuzzle.auth.updateMyCredentials('local', {
              password: passwords.value.password
            });
            passwords.value.password = null;
            passwords.value.confirmPassword = null;
          }
          isSubmiting.value = false;
          root.$bvToast.toast('Profile updated', {
            title: 'Success',
            autoHideDelay: 5000,
            variant: 'success',
            appendToast: true
          });
          await root.$store.dispatch('auth/FETCH_CURRENT_USER', root.$kuzzle);
        } catch (e) {
          root.$bvToast.toast(`${e}`, {
            title: 'Error',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          });
          isSubmiting = false;
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.form-group {
  text-align: left;
}
.eye-icon {
  cursor: pointer;
}
.group-text {
  min-width: 47px;
}
</style>
